import React, { useCallback, useEffect, useState } from 'react';
import { Alert } from '@brokerbay/design-components';
import { getBalanceAndDate } from 'api/BillingController';
import { featureEnabled } from 'utils';

type BalanceAlertProps = BalanceAlertForUser | BalanceAlertForOrg;
type BalanceAlertForUser = {
  orgId: string;
  userId: string;
  type: 'user';
};
type BalanceAlertForOrg = {
  orgId: string;
  type: 'org';
};

const BalanceAlert = (props: BalanceAlertProps) => {
  const [balance, setBalance] = useState<number | null>(null);

  const isBalanceForUser = useCallback(
    (input: unknown): input is BalanceAlertForUser => {
      const { type } = props;
      return type === 'user';
    },
    [props],
  );

  useEffect(() => {
    const fetchBalance = async () => {
      if (isBalanceForUser(props)) {
        const { orgId, userId } = props;
        if (!orgId || !userId) return;
        const { balance: balanceRes } = await getBalanceAndDate(orgId, userId);
        setBalance(balanceRes);
      } else {
        const { orgId } = props;
        if (!orgId) return;
        const { balance: balanceRes } = await getBalanceAndDate(orgId);
        setBalance(balanceRes);
      }
    };

    fetchBalance();
  }, [isBalanceForUser, props]);

  if (!balance || featureEnabled('keyholderBillingFeature')) return null;

  return (
    <Alert
      type="error"
      message="Your account has an overdue balance. Please update your payment method at your earliest convenience."
    />
  );
};

export default BalanceAlert;
